import React, {Component} from 'react';
import Relay from 'react-relay';
import cookie from '../../helper/cookie'

class Settings extends Component {
  static propTypes = {
    viewer: React.PropTypes.object.isRequired
  };

  constructor(props)
  {
    super(props);
    var data = [];
    this.props.viewer.conversations.map((object, index) => {
      data.push({
        pid:object.pid,
        name:object.name,
        status:object.status
      });
    });

    this.state={proj:data}
  }

 render()
  { 
    if (cookie.get('access_token') != null) {
      return(
        <div>
          <br />
          <h1 className="text-center">Your Projects</h1>
          <br />
          <br />
          <br />
          {
            this.state.proj.map(
              function(temp,i)
              {
                if(i%2==1)
                {
                  if(i==this.state.proj.length-1)
                  {
                      return(
                        <div>
                          <RowProject left={this.state.proj[i-1]} right={temp} type="1"/>
                          <RowProject type="3" />
                        </div>
                    );
                  }
                  else {
                        return(< RowProject left={this.state.proj[i-1]} right={temp} type="1"/>);
                  }
                }
                if(i+1==this.state.proj.length)
                {

                  if(i%2==0)
                  {
                    return (< RowProject left={temp} type="2"/>);
                  }
                }
              }.bind(this)
            )

          }

        </div>
      );
  }
  else{
    window.location.href = "/#/login";
    return(<div></div>);
  }
  }
}

class RowProject extends Component{
  constructor(props)
  {
    super(props);

  }
  render()
  {
    if(this.props.type=="1"){
      return(
        <div>
          <div className="row">
              <div className="col-md-3"></div>
              <Project det={this.props.left}/>
              <Project det={this.props.right}/>
          </div>
          <br />
        </div>

      );
    }
    else if(this.props.type=="2"){
      return(
        <div>
          <div className="row">
              <div className="col-md-3"></div>
              <Project det={this.props.left}/>
              <ToaddPoject />
          </div>
          <br />
        </div>

      );
    }
    else {
      return(
        <div>
          <div className="row">
              <div className="col-md-3"></div>
              <ToaddPoject />
            </div>
          <br />
        </div>

      );
    }

  }
}

class Project extends Component {
  
  constructor(props)
  {
    super(props);

    this.state={clicked:false};
    this.openProject=this.openProject.bind(this);
  }

  openProject() {
    this.setState({clicked:true});
  }

  render()
  {
    var st={
      attri:{
        border: "solid 2px #1a84eb",
        height:"200px",
        borderRadius:"6px",
        cursor:"pointer"

      },
      padd:{
        paddingTop:"66px",
        color: "#1a84eb",
        fontSize: "22px",
        letterSpacing: "0.7px",
      },
      sm:{
        fontSize: "14px",
        color: "#1a84eb",
      },

    }

    if(this.state.clicked){
      window.location.href = "/#/" + cookie.get('userId') + "/project/" + this.props.det.pid;
    }

    return(
      <div className="col-md-3" onClick={this.openProject}>
        <div className="row">
          <div className="col-md-11 btn-default" style={st.attri}>
            <h5 className="text-center text-uppercase" style={st.padd}>{this.props.det.name} </h5>
            <p className="small text-center" style={st.sm}>Status: {this.props.det.status}</p>
          </div>
          <div className="col-md-1"></div>
        </div>
      </div>
    );
  }
}

class ToaddPoject extends Component
{
  constructor(props)
  {
    super(props);

    this.state={clicked:false};
    this.createProject=this.createProject.bind(this);
  }

  createProject() {
    this.setState({clicked:true});
  }

  render()
  {
    var st={
      padd:{
        paddingTop:"66px",
        color: "#1a84eb",
        fontSize: "22px",
        letterSpacing: "0.7px",
      },
      sm:{
        fontSize: "14px",
        color: "#1a84eb",
      },
      glyp:{
        color: "#1a84eb",
        fontSize:"42px",

      },
      attri_2:{
        border: "solid 2px #1a84eb",
        height:"200px",
        borderRadius:"6px",
        borderStyle:"dotted",
        cursor:"pointer"
      },
    }

    if(this.state.clicked){
      window.location.href = "/#/create"
    }

    return(

      <div className="col-md-3" onClick={this.createProject}>
        <div className="row">
          <div className="col-md-11 btn-default" style={st.attri_2}>
          <p className="text-center" style={st.padd}>
            <a>
              <span className="glyphicon glyphicon-plus" style={st.glyp}></span>
            </a>
          </p>
          <p className="small text-center" style={st.sm}>Start a new project</p>

          </div>
        </div>
      </div>

    );
  }
}

export default Relay.createContainer(Settings, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on User {
        name
        pid
        conversations {
          pid
          id
          name
          status
          linkToReview
          linkToReport
          step
          customer{
            email
            pid
          }
          startDate
          agentId
          agent{
            name
          }
        }
      }
    `
  }
});




/** WEBPACK FOOTER **
 ** ./src/views/manageProjects/index.js
 **/